// extracted by mini-css-extract-plugin
export default {"root":"W7Oa3WEApFfBt51yfAAu","link":"ik81zg7UZIdN_qsGCj47","trunc":"C2XUzLGobD2UCawgfNmA"};